import React from 'react';
import ErrorLayout from '../../components/ErrorLayout';

const ServiceUnavailable = () => (
  <ErrorLayout 
    code={503} 
    title="Service Unavailable" 
    message="The server is temporarily down for maintenance. Please try again later." 
    icon="pi pi-wrench" 
    color="#7f8c8d" 
  />
);
export default ServiceUnavailable;